export interface AreaWithSuggestion extends Area {
  suggestion: AreaSuggestion;
}
interface AreaSuggestion {
  displayName: string;
  type: string;
}
interface Area<Parent extends number | AreaParent = AreaParent> {
  id: number;
  name: string;
  type: AreaType;
  path: string;
  parent?: Parent;
  hidden: number;
  preposition: Preposition;
  size: number;
}
interface AreaParent {
  id: number;
  name: string;
  type: AreaType;
  path: string;
  hidden: number;
  preposition: Preposition;
}

export enum Preposition {
  I = 'i',
}

export enum AreaType {
  Country = 'country',
  County = 'county',
  Municipality = 'municipality',
  SuburbAndLocality = 'suburb,locality',
  Suburb = 'suburb',
  Locality = 'locality',
  Custom = 'custom',
  PopulatedArea = 'populatedArea',
  StreetName = 'streetName',
  undefined = 'undefined',
  PostCode = 'postcode',
  Top = 'top',
  UserDefined = 'userDefined',
  IndexArea = 'indexArea',
  Deso = 'deso',
  DesoCluster = 'desoCluster',
}
export const AreaTypeTranslation: Record<string, string> = {
  country: 'Land',
  county: 'Län',
  municipality: 'Kommun',
  'suburb,locality': 'Stadsdel',
  suburb: 'Stadsdel',
  locality: 'Stadsdel',
  custom: 'Område',
  populatedArea: 'Tätort',
  streetName: 'Gata',
  undefined: 'undefined',
  postCode: 'Postnummer',
  top: 'Top',
  userDefined: 'Område',
  indexArea: 'Indexområde',
  deso: 'Deso',
  desoCluster: 'Deso-kluster',
};

type LatLngTuple = [number, number];
type PolygonRing = LatLngTuple[];
type PolygonAPI = Record<string, PolygonRing[]>;

export type { Area, AreaParent, LatLngTuple, PolygonAPI, PolygonRing };
